[
  {
    "code": "KM-A",
    "name": "Anjouan"
  },
  {
    "code": "KM-G",
    "name": "Grande Comore"
  },
  {
    "code": "KM-M",
    "name": "Mohéli"
  }
]